import Header from "components/Headers/Header";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import {
  Container,
  Card,
  CardBody,
  Input,
  Button,
  Form,
  Table,
  Modal,
  ModalBody,
  Label,
  Spinner
} from "reactstrap";
import { getCityRequests } from "store/actions/requestedCitiesAction";
import { getAllUsers } from "store/actions/userAction";
import { updateCityRequest } from "store/actions/requestedCitiesAction";
import { createCityRequest } from "store/actions/requestedCitiesAction";
import { getSports } from "store/actions/sportAction";
import { fetchStates } from "store/actions/athleteActions";
import ReuseableTable from "components/Tables/ReuseableTable";

const RequestedCities = () => {
  let dispatch = useDispatch();
  let { uid } = useSelector((state) => state.auth);
  const { allUsers } = useSelector((state) => state.users);
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [sport, setSport] = useState("");
  const [college, setCollege] = useState("");
  const [support, setSupport] = useState([]);
  const [modal, setModal] = useState(false);
  const [loadMoreLoader, setLoadMoreLoader] = useState(false);
  const { states } = useSelector((state) => state.athlete);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  let { sports } = useSelector((state) => state.sport);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const { cityRequests, lastDocument, hasMoreDocument } = useSelector(
    (state) => state.requestedCities
  );

  const newCity = city.toLowerCase().split(" ");
  for (let i = 0; i < newCity.length; i++) {
    newCity[i] = newCity[i][0]?.toUpperCase() + newCity[i].substr(1);
  }

  const newCollege = college.toLowerCase().split(" ");
  for (let i = 0; i < newCollege.length; i++) {
    newCollege[i] = newCollege[i][0]?.toUpperCase() + newCollege[i].substr(1);
  }

  const toggle = () => {
    setModal(!modal);
    setState("");
    setCity("");
    setSport("");
    setCollege("");
  };

  const defaultStateProps = {
    options: states?.map((insti) => {
      return insti.name;
    }),
    getOptionLabel: (option) => option
  };

  const loadMore = () => {
    if (!hasMoreDocument) return;
    setLoadMoreLoader(true);
    dispatch(
      getCityRequests(lastDocument, () => {
        setLoadMoreLoader(false);
      })
    );
  };

  useEffect(() => {
    if (states.length == 0) {
      dispatch(fetchStates());
    }
  }, []);

  useEffect(() => {
    let unsubscribe;
    if (cityRequests.length === 0) {
      setLoading(true);
      unsubscribe = dispatch(
        getCityRequests("", () => {
          setLoading(false);
        })
      );
    }
    return () => {
      if (unsubscribe && typeof unsubscribe === "function") unsubscribe();
    };
  }, [dispatch, cityRequests.length]);

  useEffect(() => {
    let unsubscribe;
    if (allUsers.length == 0) {
      setLoadMoreLoader(true);
      unsubscribe = dispatch(getAllUsers());
      setLoadMoreLoader(false);
    }
    return () => {
      if (unsubscribe && typeof unsubscribe === "function") unsubscribe();
    };
  }, [dispatch, allUsers.length]);

  useEffect(() => {
    const unsubscribe = dispatch(getSports());
    return () => {
      if (unsubscribe && typeof unsubscribe === "function") unsubscribe();
    };
  }, [dispatch]);

  // HandleSupport Click
  const handleHeartClick = (id, arr) => {
    if (arr.includes(uid)) {
      let checkedArr = arr.filter((item) => item !== uid);
      dispatch(updateCityRequest(id, checkedArr));
    } else {
      let obj = [...arr, uid];
      dispatch(updateCityRequest(id, obj));
    }
  };

  // AutoComplete Option For Sport

  const defaultSportProps = {
    options: sports.map((insti) => {
      return insti.sport;
    }),

    getOptionLabel: (option) => option
  };
  const TABLE_DATA = {
    columns: [
      "State",
      "City",
      "Status",
      "My College Name",
      "My College’s Sports",
      "Support"
    ],
    keyMap: {
      State: "state",
      City: "city",
      Status: "status",
      "My College Name": "college",
      "My College’s Sports": "sport",
      Support: "support"
    },
    data: cityRequests.map((row, index) => {
      return {
        state: row.state,
        city: row.city,
        status: row.status,
        college: row.college,
        sport: row.sport,
        support: (
          <div className="d-flex justify-content-center">
            <i
              className={
                row.supported_by.includes(uid)
                  ? "fas fa-heart fa-2x text-danger pointer"
                  : "fas fa-heart fa-2x pointer"
              }
              onClick={() => handleHeartClick(row.id, row.supported_by)}
            ></i>
            <p className="pl-2">{row.support}</p>
          </div>
        )
      };
    })
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Header />

      <Modal isOpen={modal}>
        <ModalBody>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              let obj = {
                state: state,
                city: newCity.join(" "),
                college: newCollege.join(" "),
                sport: sport,
                status: "pending",
                added_by: uid,
                supported_by: support,
                support: support.length
              };
              setSubmitting(true);
              dispatch(createCityRequest(obj)).then(() => {
                toggle();
                setState("");
                setCity("");
                setCollege("");
                setSport("");
                setSubmitting(false);
              }).catch(() => {
                setSubmitting(false);
              });
            }}
          >
            <>
              <p className="auth-desc-subtitle mt-0 ml-0">Add Requested City</p>

              <div>
                <Label className="m-0 text-center">
                  <h3>State:</h3>
                </Label>
                <Autocomplete
                  {...defaultStateProps}
                  id="auto-complete"
                  autoComplete
                  includeInputInList
                  disableClearable={true}
                  disableListWrap
                  value={state}
                  onChange={(e, val) => {
                    setState(val);
                    setCity("");
                    setCollege("");
                    setSport("");
                  }}
                  renderInput={(params) => (
                    <TextField {...params} variant="standard" />
                  )}
                />
              </div>
              <div className="mt-3">
                <Label className="m-0 text-center">
                  <h3>City:</h3>
                </Label>
                <Input
                  type="text"
                  value={city}
                  style={{
                    border: "none",
                    borderRadius: "0px",
                    borderBottom: "1px solid Black",
                    color: "black"
                  }}
                  onChange={(e) => setCity(e.target.value)}
                />
              </div>
              <div className="mt-3">
                <Label className="m-0 text-center">
                  <h3>Sport:</h3>
                </Label>
                <Autocomplete
                  {...defaultSportProps}
                  id="auto-complete"
                  autoComplete
                  includeInputInList
                  disableClearable={true}
                  disableListWrap
                  value={sport}
                  onChange={(e, val) => {
                    setSport(val);
                    setCollege("");
                  }}
                  renderInput={(params) => (
                    <TextField {...params} variant="standard" />
                  )}
                />
              </div>
              <div className="mt-3">
                <Label className="m-0 text-center">
                  <h3>College:</h3>
                </Label>
                <Input
                  type="text"
                  value={college}
                  style={{
                    border: "none",
                    borderRadius: "0px",
                    height: "32px",
                    borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
                    color: "black"
                  }}
                  onChange={(e) => setCollege(e.target.value)}
                />
              </div>

              <div className="text-right">
                <Button
                  color="primary"
                  size="md"
                  className="mt-4"
                  type="submit"
                  disabled={!state || !sport || !college || !city || submitting}
                >
                  {submitting ? <Spinner size="sm" /> : "Submit"}
                </Button>
                <Button className="mt-4" color="danger" onClick={toggle} disabled={submitting}>
                  Close
                </Button>
              </div>
            </>
          </Form>
        </ModalBody>
      </Modal>
      <Container className="mt--4" fluid>
        <h2 className="text-dark mb-4 font-weight-700" style={{ fontSize: isSmallScreen ? "18px" : "26px" }}>
          My college’s city not listed. Please add.
        </h2>
        <Card className="shadow border-0 rounded-4 p-4">
          <div className="d-flex align-items-center mb-3">
            <h3 className="mb-0 text-dark font-weight-700">
              Cities
            </h3>
            <Button className="ml-auto" color="primary" onClick={toggle}>
              Add New City
            </Button>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center align-items-center py-5">
              <Spinner size="md" color="primary" />
            </div>
          ) : (
            <>
              <ReuseableTable {...TABLE_DATA} emptyMessage="No city requests submitted yet." />
              <div className="w-100  p-3 d-flex justify-content-center">
                {cityRequests?.length > 4 && hasMoreDocument && (
                  <div className="text-center">
                    <Button
                      color="primary"
                      onClick={loadMore}
                      disabled={!hasMoreDocument || loadMoreLoader}
                    >
                      {loadMoreLoader ? <Spinner size="sm" /> : "Load more"}
                    </Button>
                  </div>
                )}
              </div>
            </>
          )}
        </Card>
      </Container>
    </>
  );
};

export default RequestedCities;
